



import { useState } from "react";
import { Pencil, Save, X } from "lucide-react";

const Skills = () => {
    const [isEditing, setIsEditing] = useState(false);
    const [formData, setFormData] = useState({
        skill: "ReactJS Developer ",
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSave = () => {
        setIsEditing(false);
    };

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Skills</h5>
                <div>
                    {isEditing && (
                        <button onClick={handleSave} className="btn btn-success btn-sm me-2">
                            <Save size={18} className="me-1" /> Save
                        </button>
                    )}
                    <button onClick={() => setIsEditing(!isEditing)} className="border-0 bg-transparent">
                        {isEditing ? <X className="text-danger" size={20} /> : <Pencil className="text-primary" size={20} />}
                    </button>
                </div>
            </div>

            <div className="card-block">
                <div className="row">
                    {/* Skills */}
                    <div className="col-lg-12 mb-3">
                        <label className="form-label">Skills</label>
                        {isEditing ? (
                            <select name="skill" className="form-control input-me f-14" value={formData.skill} onChange={handleChange}>
                                <option>ReactJS Developer</option>
                                <option>Magento Developer</option>
                            </select>
                        ) : (
                            <p className="mb-0 f-13">{formData.skill}</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Skills;
